import React from 'react'

const GoalInTimeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18.75C5.17525 18.75 1.25 14.8247 1.25 10C1.25 5.17525 5.17525 1.25 10 1.25C14.8247 1.25 18.75 5.17525 18.75 10C18.75 14.8247 14.8247 18.75 10 18.75Z"
        fill="#72C472"
      />
      <path
        d="M8.24973 14.3752C8.02573 14.3752 7.80173 14.2895 7.63111 14.1188L5.00611 11.4938C4.66398 11.1517 4.66398 10.5987 5.00611 10.2566C5.34823 9.91447 5.90123 9.91447 6.24336 10.2566L8.24973 12.263L13.7561 6.75659C14.0982 6.41447 14.6512 6.41447 14.9934 6.75659C15.3355 7.09872 15.3355 7.65172 14.9934 7.99384L8.86836 14.1188C8.69773 14.2895 8.47373 14.3752 8.24973 14.3752Z"
        fill="white"
      />
    </svg>
  )
}

export default GoalInTimeIcon
